import { numberField, optionField } from '@/common/utils/form/fieldTypes';

export const pms_overdue_jobs_percentage_limit = 'pms_overdue_jobs_percentage_limit';
export const spare_parts_inventory_survey_interval = 'spare_parts_inventory_survey_interval';
export const spare_parts_inventory_survey_interval_unit =
  'spare_parts_inventory_survey_interval_unit';
export const running_hours_report_interval_days = 'running_hours_report_interval_days';
export const pms_jobs_require_total_system_running_hours_when_reported_in_the_system =
  'pms_jobs_require_total_system_running_hours_when_reported_in_the_system';
export const pms_assign_system_and_subsystem_or_assignment_to_group =
  'pms_assign_system_and_subsystem_or_assignment_to_group';
export const pms_vessel_system_assignment_description_pattern =
  'pms_vessel_system_assignment_description_pattern';
export const pms_first_job_status_properties = 'pms_first_job_status_properties';

export type SparePartsInventorySurveyIntervalUnit =
  | {
      label: string;
      value: string;
    }
  | string
  | null;

export type PMSJobsRequireTotalSystemRunningHoursWhenReportedInTheSystem =
  | {
      label: string;
      value: string;
    }
  | string
  | null;

export type PMSAssignSystemAndSubsystemOrAssignmentToGroup =
  | {
      label: string;
      value: string;
    }
  | string
  | null;

export type PMSVesselSystemAssignmentDescriptionPattern =
  | {
      label: string;
      value: string;
    }
  | string
  | null;

export type PMSDefaultJobStatusProgress = {
  label: string;
  value: { progress: 'not_started'; edit_side: 'office' | 'vessel' };
} | null;

export type PMSSettingsType = {
  [pms_overdue_jobs_percentage_limit]: string;
  [spare_parts_inventory_survey_interval]: string;
  [spare_parts_inventory_survey_interval_unit]: SparePartsInventorySurveyIntervalUnit;
  [running_hours_report_interval_days]: string;
  [pms_jobs_require_total_system_running_hours_when_reported_in_the_system]: PMSJobsRequireTotalSystemRunningHoursWhenReportedInTheSystem;
  [pms_assign_system_and_subsystem_or_assignment_to_group]: PMSAssignSystemAndSubsystemOrAssignmentToGroup;
  [pms_vessel_system_assignment_description_pattern]: PMSVesselSystemAssignmentDescriptionPattern;
  [pms_first_job_status_properties]: PMSDefaultJobStatusProgress;
};

const config = {
  [pms_overdue_jobs_percentage_limit]: numberField(),
  [spare_parts_inventory_survey_interval]: numberField(),
  [spare_parts_inventory_survey_interval_unit]: optionField(),
  [running_hours_report_interval_days]: numberField(),
  [pms_jobs_require_total_system_running_hours_when_reported_in_the_system]: optionField(),
  [pms_assign_system_and_subsystem_or_assignment_to_group]: optionField(),
  [pms_vessel_system_assignment_description_pattern]: optionField(),
  [pms_first_job_status_properties]: optionField()
};

export default config;
